angular.module("myApp").service("forcehttp", function ($http, $q, $timeout, Notification) {
  this.get = (url, silent = false) => {
    let had_warnings = false

    const warnOnce = () => {
      if (!had_warnings) {
        if (!silent) {
          Notification.warning("Serveris neatsaucas, mēģināšu vēlreiz pēc mirklīša, tev nekas nav jādara")
        }
        had_warnings = true
      }
    }

    const impl = () => {
      return $http
        .get(url)
        .then((d) => {
          if (!d.data?.id) {
            console.log("Server not giving user id")
            warnOnce()
            return $timeout(impl, 3000)
          }
          if (had_warnings) {
            if (!silent) {
              Notification.success("Serveris darbojas.")
            }
            had_warnings = false
          }
          return d
        })
        .catch((e) => {
          if (e.data?.includes("ECONNREFUSED")) {
            // eslint-disable-next-line no-console
            console.log(`Server gone/not ready, retry in a moment`)
            warnOnce()
            return $timeout(impl, 3000)
          }
          return $q.reject(e)
        })
    }

    return impl()
  }
})
